import { render, staticRenderFns } from "./hangupDetails.vue?vue&type=template&id=324fb074&"
import script from "./hangupDetails.vue?vue&type=script&lang=js&"
export * from "./hangupDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports